const reviews = [
  {
    id: 1,
    name: "John Doe",
    rating: 5,
    text: "Great experience — highly recommended!",
  },
  {
    id: 2,
    name: "Jane Smith",
    rating: 4,
    text: "Very professional and quick service.",
  },
  {
    id: 3,
    name: "Emily Parker",
    rating: 5,
    text: "Outstanding quality work and customer service!",
  },
  {
    id: 4,
    name: "Michael Brown",
    rating: 3,
    text: "Good overall but a bit slow response.",
  },
];

export default reviews;